module.exports = __webpack_public_path__ + "stylesheets/m-wave-typography_1ef6ce722035590a2f1bd6ea1d170b68.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/mobile/wave/m-wave-typography.less
// module id = BTge
// module chunks = 118